import React from "react";

export default function Unauthenticated() {
    return (
        <div className="pds-unauthenticatedError-background">
            <section className="pds-imgStanTheMan pds-util-padding-top-20 pds-util-padding-bottom-10">
                <div className="pds-typography-center">
                    <div>
                        <h1 className="pds-typography-h2 pds-util-margin-top-10 pds-util-margin-bottom-0">
                            Firm Contact Application Access Error
                        </h1>
                    </div>
                    <div className="pds-util-padding-horz-10">
                        <div className="pds-util-margin-vert-0">
                        <br/>
                            It looks like you don't have permission to view this page. <br/>
                            If you think you should have permission, <br/>
                            contact DTS (800-554-3395) or submit a ticket to the ADWT board. 
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
